<template>
  <div class="form-container">

    <!-- Nova Questão: Água -->
    <div class="question-group">
      <label class="required">Água Mineral:</label>
      <div class="checkbox-group">
        <label v-for="(agua, index) in aguas" :key="index">
              <input 
              type="radio"
              name="agua" 
              v-model="cardapio.agua" 
              :value="agua" 
              :onchange="emitirCardapio"/> {{  agua }}
        </label>
      </div>
    </div>
    <div class="itens-selecionados">
      Água selecionada: {{ cardapio.agua }}
    </div>

    <!-- Nova Questão: Café -->
    <div class="question-group">
      <label class="required">Café Sem Açúcar:</label>
      <div class="checkbox-group">
        <label v-for="(cafe, index) in cafes" :key="index">
              <input 
              type="radio"
              name="cafe" 
              v-model="cardapio.cafe" 
              :value=" cafe" 
              :onchange="emitirCardapio"/> {{  cafe }}
        </label>
      </div>
      <div class="instrucoes">
        adoçante e açúcar a parte
      </div>
    </div>
    <div class="itens-selecionados">
      Café selecionado: {{ cardapio.cafe }}
    </div>

    <!-- Questão do Suco -->
     <br />
    <div class="question-group">
      <label class="required">Néctar de Frutas:</label>
      <div class="checkbox-group">
        <label v-for="(suco, index) in sucos" :key="index">
              <input 
              type="checkbox" 
              name="sucos"
              :disabled="cardapio.sucos.length >= 2 && !cardapio.sucos.includes(suco)" 
              v-model="cardapio.sucos" 
              :value="suco" 
              @change="handleSucosClick"/> {{ suco }}
        </label>
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Suco(s) selecionado(s): {{ cardapio.sucos.join(', ') }}
    </div>

    <!-- Nova Questão: Chá -->
    <div class="question-group">
      <label class="required">Chá Matte:</label>
      <div class="checkbox-group">
        <label v-for="(c, index) in cha" :key="index">
              <input 
              type="radio"
              name="cha" 
              v-model="cardapio.cha" 
              :value="c" 
              :onchange="emitirCardapio"/> {{  c }}
        </label>
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Chá selecionado: {{ cardapio.cha }}
    </div>

    <!-- Nova Questão: Salgado Assado -->
    <div class="question-group">
      <label class="required">Salgado Assado:</label>
      <div class="checkbox-group">
          <label v-for="(assado, index) in assados" :key="index">
              <input 
              type="checkbox" 
              :disabled="cardapio.assados.length >= 2 && !cardapio.assados.includes(assado)" 
              v-model="cardapio.assados" 
              :value="assado" 
              :onchange="emitirCardapio" /> {{ assado }}
        </label>           
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Assado selecionado: 
      <span v-if="cardapio.assados.length > 0">
        {{ cardapio.assados.join(', ') }}
      </span>
    </div>


    <!-- Nova Questão: Salgado Vegetariano-->
    <div class="question-group">
      <label class="required">Salgados Assados Vegetarianos </label>
      <div class="checkbox-group">
          <label v-for="(vegetariano, index) in vegetarianos" :key="index">
              <input type="radio" name="vegetariano" v-model="cardapio.vegetariano" :value="vegetariano" :onchange="emitirCardapio"/>
              {{ vegetariano }}
          </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Salgado selecionado: 
      <span>
        {{ cardapio.vegetariano }}
      </span>
    </div>

    <!-- Nova Questão: Lanche no Pão Integral -->
    <div class="question-group">
      <label class="required">Lanche no Pão de Forma Integral </label>
      <div class="checkbox-group">
          <label v-for="(lanche, index) in lanches" :key="index">
              <input type="radio" name="lanche" v-model="cardapio.lanche" :value="lanche" :onchange="emitirCardapio"/>
              {{ lanche }}
          </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Lanche selecionado: 
      <span>
        {{ cardapio.lanche }}
      </span>
    </div>

    <!-- Nova Questão: Sanduiche Individual (baguete)-->
    <div class="question-group">
      <label class="required">Sanduíche na Baguete</label>
      <div class="checkbox-group">
          <label v-for="(sanduiche, index) in sanduiches_B" :key="index">
              <input type="radio" name="sanduiches_B" v-model="cardapio.sanduiche_B" :value="sanduiche" :onchange="emitirCardapio"/>
              {{ sanduiche }}
        </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Sanduíche selecionado: 
      <span>
        {{ cardapio.sanduiche_B }}
      </span>
    </div>

    <!-- Nova Questão: Sanduiche Individual (ciabatta)-->
    <div class="question-group">
      <label class="required">Sanduíche na Ciabatta</label>
      <div class="checkbox-group">
          <label v-for="(sanduiche, index) in sanduiches_C" :key="index">
              <input type="radio" name="sanduiches_C" v-model="cardapio.sanduiche_C" :value="sanduiche" :onchange="emitirCardapio"/>
              {{ sanduiche }}
        </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Sanduíche selecionado: 
      <span>
        {{ cardapio.sanduiche_C }}
      </span>
    </div>

    <!-- Nova Questão: Doces -->
    <div class="question-group">
      <label class="required">Doces Individuais</label>
      <div class="checkbox-group">
          <label v-for="(doce, index) in doces" :key="index">
           <input 
              type="checkbox" 
              :disabled="cardapio.doces.length >= 2 && !cardapio.doces.includes(doce)" 
              v-model="cardapio.doces" 
              :value="doce" 
              :onchange="emitirCardapio" /> {{ doce }}


        </label>           
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Doce(s) selecionado(s): 
      <span>
        {{ cardapio.doces.join(', ') }}
      </span>
    </div>

    <!-- Nova Questão: Bolo -->
    <div class="question-group">
      <label class="required">Bolo</label>
      <div class="checkbox-group">
          <label v-for="(bolo, index) in bolos" :key="index">
              <input type="radio" name="bolo" v-model="cardapio.bolo" :value="bolo" :onchange="emitirCardapio"/>
              {{ bolo }}

        </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Bolo(s) selecionado(s): 
      <span>
        {{ cardapio.bolo }}
      </span>
    </div>

    <!-- Nova Questão: Salada de Frutas -->
    <div class="question-group">
      <label class="required">Salada de Frutas:</label>
      <div class="checkbox-group">
          <label v-for="(fruta, index) in frutas" :key="index">
              <input 
              type="checkbox" 
              :disabled="cardapio.frutas.length >= 4 && !cardapio.frutas.includes(fruta)" 
              v-model="cardapio.frutas" 
              :value="fruta" 
              :onchange="emitirCardapio" /> {{ fruta }}
        </label>           
      </div>
      <div class="instrucoes">
        (4 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Fruta(s) selecionada(s): 
      <span v-if="cardapio.frutas.length > 0">
        {{ cardapio.frutas.join(', ') }}
      </span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    tipoCardapio: {
      type: Number,
      default: null
    },
  },
  data() {
    return {

      doces:[
        'Lua de Mel (creme)',
        'Lua de Mel (doce de leite)',
        'Mini Tartelete com Creme de Confeiteiro com Morangos',
        'Mini Tartelete com Creme de Confeiteiro com Raspas de Limão ou Mousse de Limão',
        'Mini Tartelete com Creme de Confeiteiro com Frutas Amarelas (Manga, Pêssego, Damasco)',
        'Mini Brownie (30g)',
      ],

      bolos: [
        'Cenoura com Cobertura de Chocolate',
        'Chocolate com Cobertura de Chocolate',
        'Fubá com Cobertura de Goiabada',
        'Bolo de Maçã com Especiarias e Cobertura de Fondant',
        'Bolo de Iogurte com Cobertura de Geleia de Frutas Vermelhas ou Morangos',
      ],

      assados: [
        'Mini Croissant de Frango',
        'Mini Croissant de Presunto e Queijo',
        'Mini Pão de Batata com Frango',
        'Mini Quiche Lorraine (Bacon e Alho Poró)',
      ],

      sanduiches_B: [
        'Salame, Queijo Muçarela, Alface, Tomate, Maionese',
        'Queijo Branco, Peito de Peru, Alface, Cenoura Ralada e Maionese',
      ],

      sanduiches_C: [
        'Mortadela com Geleia de Frutas Amarelas (Abacaxi, Manga, Pêssego ou Damasco)',
        'Antepasto de Berinjela com Queijo Muçarela',
      ],

      vegetarianos: [
        'Mini quiche de Alho Poró',
        'Mini quiche de Espinafre',
        'Mini Folhado de Queijo',
        'Mini Pão de Batata com Requeijão Cremoso',
      ],

      lanches: [
        'Frango Desfiado com Requeijão, Alface, Cenoura Ralada',
        'Queijo Prato, Rúcula, Tomate Seco',
      ],

      cha: [
        'Quente com limão',
        'Quente sem limão',
        'Frio com limão',
        'Frio sem limão',
        'Não',
      ],

      aguas: [
        'Sim',
        'Não',
      ],

      cafes: [
        'Sim',
        'Não',
      ],

      sucos: [
        'Abacaxi',
        'Laranja',
        'Pêssego',
        'Goiaba',
        'Uva',
        'Manga',
        'Caju',
        'Maracujá',
      ],

      frutas: [
        'Abacaxi',
        'Manga',
        'Maçã',
        'Melão',
        'Morango',
        'Uva',
      ],

      cardapio: {
        tipoCardapio: null,
        sucos: [],
        agua: '', 
        cafe: '',
        cha: '',
        assados: [],
        lanche: '',
        sanduiche_B: '',
        sanduiche_C: '',
        vegetariano: '',
        bolo: '',
        doces: [],
        frutas: []
      },
    };
  },

  methods: {

    resetCardapio(){

      this.cardapio = {
        tipoCardapio: null,
        sucos: [],
        agua: '', 
        cafe: '',
        cha: '',
        assados: [],
        lanche: '',
        sanduiche_B: '',
        sanduiche_C: '',
        vegetariano: '',
        bolo: '',
        doces: [],
        frutas: []
      }
    },

    emitirCardapio() {
      this.$emit('atualizar-cardapio', this.cardapio);
    }

  },

  created(){

  },

  mounted() {
    this.resetCardapio();
  },

  computed: {

  }
};
</script>
  
<style src="../css/buffet.css"></style>

